// ABOUTME: The clouds of the stack with their contents: the storm and weather ones are shared by the stack and by the screens' live tiers.
// ABOUTME: A missing reading draws an empty cloud, never nothing, so the stack always has all four tiers.

import { Box, Typography } from '@mui/material';
import CloudBlob from '../../crossing/CloudBlob';
import FeelingFaceIcon from '../../crossing/FeelingFaceIcon';
import {
  FEELING_HUES, CROSSING_NEUTRAL_FILL, CROSSING_GROUND, CROSSING_ARROW_BORDER,
  CROSSING_CLOUD_GHOST, CROSSING_CLOUD_REVEAL, CROSSING_CLOUD_STORM, CROSSING_CLOUD_FEELING, CROSSING_CLOUD_INK,
} from '../../../../theme/crossingTokens';
import type { CrossingFeelingDto, CrossingStormDto, CrossingWeatherPatternDto } from '../../../../types/api';

const EMPTY = <Box sx={{ minHeight: 24 }} />;

export function WeatherBlob({ weather }: { weather?: CrossingWeatherPatternDto }) {
  return (
    <CloudBlob color={CROSSING_CLOUD_GHOST} maxWidth={weather ? 400 : 480} minWidth={weather ? 320 : 400}>
      {weather ? (
        <>
          <Typography sx={{ fontFamily: 'Newsreader, serif', fontSize: '26px', fontWeight: 600, color: CROSSING_CLOUD_INK }}>
            {weather.name}
          </Typography>
          <Typography sx={{ fontSize: '11px', fontWeight: 800, letterSpacing: '1.4px', color: CROSSING_CLOUD_INK, textTransform: 'uppercase' }}>
            MY WEATHER RESPONSE
          </Typography>
        </>
      ) : EMPTY}
    </CloudBlob>
  );
}

export function RevealBlob({ heading, text }: { heading?: string; text?: string }) {
  return (
    <CloudBlob color={CROSSING_CLOUD_REVEAL} maxWidth={400} minWidth={320}>
      {heading ? (
        <>
          <Typography sx={{ fontSize: '13px', fontWeight: 800, letterSpacing: '1.4px', color: CROSSING_CLOUD_INK, textTransform: 'uppercase', mb: 1 }}>
            {heading}
          </Typography>
          <Typography sx={{ fontFamily: 'Newsreader, serif', fontSize: '17px', fontWeight: 600, color: CROSSING_CLOUD_INK, lineHeight: 1.35 }}>
            {text}
          </Typography>
        </>
      ) : EMPTY}
    </CloudBlob>
  );
}

export function StormBlob({ storm }: { storm?: CrossingStormDto }) {
  return (
    <CloudBlob color={CROSSING_CLOUD_STORM} maxWidth={340} minWidth={260}>
      {storm ? (
        <>
          <Typography sx={{ fontFamily: 'Newsreader, serif', fontSize: '26px', fontWeight: 600, color: CROSSING_CLOUD_INK }}>
            {storm.name}
          </Typography>
          <Typography sx={{ fontSize: '14px', color: CROSSING_CLOUD_INK }}>{storm.plainPhrase}</Typography>
        </>
      ) : EMPTY}
    </CloudBlob>
  );
}

export function FeelingBlob({ feeling, layer }: { feeling?: CrossingFeelingDto; layer?: 'fill' | 'content' }) {
  return (
    <CloudBlob color={CROSSING_CLOUD_FEELING} maxWidth={460} minWidth={380} layer={layer}>
      {feeling ? (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
          <Typography sx={{ fontSize: '20px', fontWeight: 800, letterSpacing: '1px', color: CROSSING_CLOUD_INK, textTransform: 'uppercase' }}>
            {feeling.name}
          </Typography>
          <Box
            sx={{
              width: 48, height: 48, borderRadius: '10px', backgroundColor: CROSSING_GROUND,
              border: `1.5px solid ${CROSSING_ARROW_BORDER}`, display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}
          >
            <FeelingFaceIcon code={feeling.code} hue={FEELING_HUES[feeling.code] ?? CROSSING_NEUTRAL_FILL} size={30} />
          </Box>
        </Box>
      ) : EMPTY}
    </CloudBlob>
  );
}
